export default defineNuxtPlugin((nuxtApp) => {
  const navigationDirection = useNavigationDirection();

  window.addEventListener("popstate", () => {
    navigationDirection.value = "back";
  });

  nuxtApp.$router.afterEach(() => {
    window.setTimeout(() => {
      navigationDirection.value = "forward";
    }, 0);
  });
});
